const featureNames = {
  en: { levelUp: 'Level Up', tournament: 'World Tournament', triumph: 'Sentence Archive' },
  ko: { levelUp: '카드 레벨업', tournament: '세계 대회', triumph: '문장 보관함' },
};

export default featureNames;
